import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';

export function createTranslateLoader(): TranslateLoader {
  return new TranslateHttpLoader();
}